import React from "react";

const payBtnStyle = {
  display: "inline-block",
  marginLeft: "8px",
  padding: "2px 10px",
  backgroundColor: "#4CAF50",
  color: "#fff",
  borderRadius: "4px",
  fontSize: "0.8em",
  fontWeight: "bold",
  textDecoration: "none",
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

class Registration extends React.Component {
  componentDidMount() {
    document.title =
      "Registration - 15th International Conference on Information Technology and Applications (ICITA)";
  }

  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <div className="col text-center">
                  <div className="section_title_container text-center">
                    <div className="contact_title">
                      <h1>Conference Registration</h1>
                    </div>
                  </div>

                  <div className="intro_left_content text_left">
                    <p align="left">
                      All accepted papers will be published in the{" "}
                      <a
                        href="https://www.springer.com/series/15179"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Lecture Notes in Network Systems Series
                      </a>
                      . The event is organised in a hybrid mode. In-person and
                      virtual attendance options are available. Register early
                      to benefit from reduced rates.
                    </p>

                    <p align="left">
                      <strong>
                        ⚠️ At least one author per accepted paper must register
                        by{" "}
                        <span style={{ color: "red" }}>14 September 2026</span>{" "}
                        for the paper to be included in the proceedings.
                      </strong>
                    </p>

                    {/* Early-Bird Registration */}
                    <h4 style={{ color: "green", marginTop: "20px" }}>
                      Early-Bird Registration (Deadline: 1 Sept 2026)
                    </h4>
                    <table
                      style={{ width: "100%" }}
                      border="1"
                      cellSpacing="0"
                      cellPadding="6"
                    >
                      <tbody>
                        <tr
                          style={{ backgroundColor: "#f2f2f2", color: "black" }}
                        >
                          <td>
                            <strong>Category</strong>
                          </td>
                          <td>
                            <strong>Type</strong>
                          </td>
                          <td>
                            <strong>In-Person (USD)</strong>
                          </td>
                          <td>
                            <strong>Virtual (USD)</strong>
                          </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                          <td rowSpan="2" valign="left">
                            Early-Bird
                          </td>
                          <td valign="left">Student</td>
                          <td>
                            <b style={{ color: "green" }}>$450</b>
                            <a
                              href="https://buy.stripe.com/cNi14oaZ4daDcnffsg8k808"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                          <td>
                            <b style={{ color: "green" }}>$280</b>
                            <a
                              href="https://buy.stripe.com/fZu7sM0kqdaDgDv1Bq8k809"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                          <td valign="left">Non-Student</td>
                          <td>
                            <b style={{ color: "green" }}>$550</b>
                            <a
                              href="https://buy.stripe.com/00wdRaebg7Qj72V4NC8k80a"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                          <td>
                            <b style={{ color: "green" }}>$310</b>
                            <a
                              href="https://buy.stripe.com/bJe6oIffkb2v0Exeoc8k80b"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* Regular Registration */}
                    <h4 style={{ color: "maroon", marginTop: "24px" }}>
                      Regular Registration (After Early-Bird Deadline)
                    </h4>
                    <table
                      style={{ width: "100%" }}
                      border="1"
                      cellSpacing="0"
                      cellPadding="6"
                    >
                      <tbody>
                        <tr
                          style={{ backgroundColor: "#f2f2f2", color: "black" }}
                        >
                          <td>
                            <strong>Category</strong>
                          </td>
                          <td>
                            <strong>Type</strong>
                          </td>
                          <td>
                            <strong>In-Person (USD)</strong>
                          </td>
                          <td>
                            <strong>Virtual (USD)</strong>
                          </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                          <td rowSpan="2" valign="left">
                            Regular
                          </td>
                          <td valign="left">Student</td>
                          <td>
                            <b>$560</b>
                            <a
                              href="https://buy.stripe.com/fZu7sM6IO8Un2MFdk88k80c"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                          <td>
                            <b>$295</b>
                            <a
                              href="https://buy.stripe.com/6oU4gAaZ4eeH9b3bc08k80d"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                          <td>Non-Student</td>
                          <td>
                            <b>$595</b>
                            <a
                              href="https://buy.stripe.com/9B69AUc38daD86Z4NC8k803"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                          <td>
                            <b>$345</b>
                            <a
                              href="https://buy.stripe.com/9B628s7MSgmP5YR0xm8k804"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                          <td valign="left">Attending (not presenting)</td>
                          <td>—</td>
                          <td>
                            <b>$650</b>
                            <a
                              href="https://buy.stripe.com/cNi6oI2sydaDgDva7W8k80e"
                              target="_blank"
                              rel="noreferrer"
                              style={payBtnStyle}
                            >
                              Pay
                            </a>
                          </td>
                          <td>—</td>
                        </tr>
                      </tbody>
                    </table>

                    <br />
                    <p align="left">
                      <b>
                        Registration fees are non-transferrable and
                        non-refundable.
                      </b>{" "}
                      If you have paid for in-person attendance but are unable
                      to travel, you may switch to virtual presentation. Student
                      registrants will be asked to provide proof of student
                      status at the registration desk.
                    </p>

                    <hr />

                    {/* What's Included */}
                    <h4>What's Included</h4>
                    <div
                      style={{ display: "flex", gap: "32px", flexWrap: "wrap" }}
                    >
                      <div style={{ flex: 1, minWidth: "200px" }}>
                        <h5>🏨 In-Person Registration</h5>
                        <ul style={{ textAlign: "left" }}>
                          <li>Publication of 1 accepted paper</li>
                          <li>Access to all conference sessions</li>
                          <li>Buffet lunch each day</li>
                          <li>Coffee breaks</li>
                          <li>Printed conference materials</li>
                        </ul>
                      </div>
                      <div style={{ flex: 1, minWidth: "200px" }}>
                        <h5>🖥 Virtual Registration</h5>
                        <ul style={{ textAlign: "left" }}>
                          <li>Publication of 1 accepted paper</li>
                          <li>Access to all live sessions online</li>
                          <li>Access to recorded sessions</li>
                          <li>Digital conference proceedings</li>
                        </ul>
                      </div>
                    </div>

                    <hr />

                    {/* Key Dates */}
                    <h4>Key Dates</h4>
                    <table
                      style={{ width: "100%" }}
                      border="1"
                      cellSpacing="0"
                      cellPadding="6"
                    >
                      <tbody>
                        <tr style={{ backgroundColor: "#f2f2f2" }}>
                          <td>
                            <strong>Milestone</strong>
                          </td>
                          <td>
                            <strong>Date</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>Early-Bird Closes</td>
                          <td>1 September 2026</td>
                        </tr>
                        <tr>
                          <td>Author Must Register By</td>
                          <td>14 September 2026</td>
                        </tr>
                        <tr>
                          <td>Conference Dates</td>
                          <td>14–16 Oct 2026</td>
                        </tr>
                      </tbody>
                    </table>

                    <br />
                    <p align="left">
                      For registration queries, email chair [@] icita.world
                      International participants requiring a visa to attend may
                      request an official invitation letter upon completing
                      registration and payment.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Registration;
